export default "__VITE_ASSET__4f60d38b__"